import { z } from 'zod'
import { oc } from '@orpc/contract'

export const getOrganizationConnect = oc
  .route({ method: 'GET', path: '/v2/organizations/connects/{id}' })
  .input(z.object({ id: z.string() }))
  .output(
    z.object({
      id: z.string(),
      status: z.enum(['pending', 'accepted', 'declined']),
      initiator: z.object({ id: z.string(), name: z.string() }),
      recipientEmail: z.string().nullable(),
      createdAt: z.string(),
    }),
  )
